import * as React from 'react'
import { on, off } from '@arsenal/arsenal/modules/event'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Router } from 'next/router'

import UsedcarLink from './car/usedcar-link'
import scrollSmoothly from 'lib/scroll-smoothly'

const jumpTopIcon = require('static/jump-top.png')

interface IProps {
  bottom?: number
  style?: React.CSSProperties
}

export default function BackToTop({ bottom = 0, style }: IProps) {
  const [show, updateShow] = React.useState(false)
  const [url, setUrl] = React.useState('')

  const routeChangeComplete = React.useCallback((url: string) => {
    if (url === '') {
      setUrl('/')
      return
    }
    setUrl(url)
  }, [])

  React.useEffect(() => {
    setUrl(window?.location?.pathname || '/')
    Router.events.on('routeChangeComplete', routeChangeComplete)
    return () => {
      Router.events.off('routeChangeComplete', routeChangeComplete)
    }
  }, [])

  const isUsedcar = React.useCallback(() => {
    return /\/usedcar\/(\d|has_related_video|car_source_types|x|,|-)+/g.test(
      url
    )
  }, [url])

  React.useEffect(() => {
    function handleScroll() {
      const scrollElement =
        document.scrollingElement || document.documentElement
      if (scrollElement.scrollTop > 100) {
        updateShow(true)
      } else {
        updateShow(false)
      }
    }
    on(document, 'scroll', handleScroll)
    return () => {
      off(document, 'scroll', handleScroll)
    }
  }, [])
  const handleButtonClick = () => {
    sendTeaCommEvent('clk_event', {
      event_id: 'right_float_nav',
      button_name: '返回顶部',
    })
    const scrollElement = document.scrollingElement || document.documentElement
    const top = scrollElement.scrollTop
    sendTeaCommEvent('return_to_top')
    scrollSmoothly(-top, { element: scrollElement })()
  }

  let bottomSize = 29
  // 如果有自定义的优先级更高
  if (bottom) {
    bottomSize = bottom
  }

  function renderTopButton() {
    return (
      <div
        className={`tw-fixed tw-bottom-${bottomSize} tw-z-100 tw-right-8`}
        style={style}
      >
        {isUsedcar() ? <UsedcarLink /> : null}
        <div
          onClick={handleButtonClick}
          className={`tw-rounded-2 tw-cursor-pointer tw-bg-white tw-pt-16 tw-pb-16 tw-pl-12 tw-pr-12 tw-flex tw-items-center`}
        >
          <img
            src={jumpTopIcon}
            className={`tw-mr-4 tw-h-24 tw-w-24 tw-object-cover tw-object-center`}
          />
          <p className={`tw-text-common-black tw-text-14`}>返回顶部</p>
        </div>
      </div>
    )
  }

  if (!show) {
    return null
  }
  return <>{renderTopButton()}</>
}
